import React from 'react';
import SafeIcon from '../common/SafeIcon';

const PREVIEW_FRAME_CLASS =
  'relative w-full min-h-[70vh] lg:min-h-[80vh] bg-white rounded-3xl overflow-hidden shadow-2xl border border-[var(--border-subtle)]';

export default function ResourcePreview({ resource }) {
  const isPdfFile = resource.type === 'file' && resource.fileFormat === 'pdf' && resource.previewLink;

  if (isPdfFile) {
    return (
      <div className={PREVIEW_FRAME_CLASS}>
        <iframe
          src={resource.previewLink}
          title={`Vista previa: ${resource.title}`}
          className="absolute inset-0 w-full h-full border-0"
        />
      </div>
    );
  }

  if (resource.type === 'file') {
    return (
      <div className={`${PREVIEW_FRAME_CLASS} flex items-center justify-center bg-[var(--bg-surface)]`}>
        <div className="text-center px-8">
          <div className="w-24 h-24 mx-auto mb-6 rounded-3xl gfi-gradient-bg flex items-center justify-center shadow-xl">
            <SafeIcon name="FileText" className="w-12 h-12 text-brand-navy" />
          </div>
          <p className="text-sm font-black text-[var(--text-main)] uppercase tracking-widest">
            {resource.format || 'Archivo'}
          </p>
          <p className="text-xs text-[var(--text-secondary)] mt-2 max-w-xs mx-auto">
            Vista previa no disponible para este formato. Usa el botón de descarga.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`${PREVIEW_FRAME_CLASS} relative aspect-[3/4] md:aspect-video lg:aspect-[4/5]`}>
      <img
        src={resource.thumbnail}
        alt={resource.title}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/5 flex items-center justify-center pointer-events-none">
        <div className="bg-white/90 backdrop-blur-md px-6 py-3 rounded-full flex items-center gap-3 shadow-xl">
          <SafeIcon name="ExternalLink" className="w-5 h-5 text-brand-navy" />
          <span className="text-[10px] font-bold text-brand-navy uppercase tracking-widest">Enlace externo</span>
        </div>
      </div>
    </div>
  );
}
